
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { Fragment } from 'react';
import { useRouter } from 'next/router';
import BasePageLayout from '#layouts/BasePageLayout/BasePageLayout';
import HeroUnit from '#components/sections/hero-unit/HeroUnit';
import ButtonShare from '#components/controls/buttons/buttonShare/ButtonShare';
import SocialMeta from '#components/common/meta/SocialMeta';
import useTranslation from 'next-translate/useTranslation';
import { isEuropaParkApp } from '#utils/isEuropaParkApp';
import PageSection from '#components/sections/page-section/PageSection';
import {
  GetNavigationDocument,
  GetStudioPageDocument,
  useGetStudioPageQuery,
} from '#types/generated/apollo-client';
import { VmsContext } from '#types/generated/graphql-types';
import { ITabItem } from '#components/navigation/tab-navigator/TabNavigator';
import TeaserGridWithFilter from '#components/grid-block/TeaserGridWithFilter';
import PageTitle from '#components/common/page-title/PageTitle';
import initializeClient from '#providers/apollo/initializeClient';
import addApolloState from '#providers/apollo/addApolloState';

interface Option extends ITabItem {
  value: {
    vmsContext: VmsContext;
    studioId: number;
  };
}

const StudioDetail = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const slug = router.query.slug as string;
  const { data } = useGetStudioPageQuery({
    variables: { slug },
  });

  const studio = data?.studioBySlug;

  if (!studio) {
    return null;
  }

  const options: Option[] = [
    {
      id: 3,
      title: t('gridTabVideos'),
      value: {
        vmsContext: VmsContext.Videos,
        studioId: studio.id,
      },
    },
    {
      id: 1,
      title: t('gridTabAudios'),
      value: {
        vmsContext: VmsContext.Audios,
        studioId: studio.id,
      },
    },
    {
      id: 2,
      title: t('gridTabSeries'),
      value: {
        vmsContext: VmsContext.Series,
        studioId: studio.id,
      },
    },
    {
      id: 4,
      title: t('gridTabLivestreams'),
      value: {
        vmsContext: VmsContext.LiveStreams,
        studioId: studio.id,
      },
    },
  ];

  const studioTitleImage = studio?.logoImageFormats?.sixteenBySeven?.medium;
  const studioLogoImage = studioTitleImage
    ? null
    : studio?.logoImageFormats?.oneByOne?.small;

  return (
    <BasePageLayout>
      <Fragment>
        <SocialMeta
          about={{
            title: studio.title,
            description: studio.shortDescription,
            image: studio?.teaserImageFormats?.sixteenByNine?.medium,
          }}
        />

        <main className="page-main-container">
          <HeroUnit
            title={studio?.title}
            titleImage={studioTitleImage}
            description={studio?.shortDescription}
            backgroundImageFormats={studio?.backgroundImageFormats}
            studioLogoImage={studioLogoImage}
            buttonComponent={
              !isEuropaParkApp() && (
                <div className="tw-flex tw-gap-1 tw-flex-wrap tw-items-center">
                  <ButtonShare
                    uri={`https://www.veejoy.de/${router.locale}${router.asPath}`}
                    title={studio.title}
                    description={studio.shortDescription}
                  />
                </div>
              )
            }
          />

          <PageSection>
            <PageTitle title={data?.studioBySlug?.title} element="h1" />
            <TeaserGridWithFilter
              options={options}
              selectedOption={options[0]}
            />
          </PageSection>
        </main>
      </Fragment>
    </BasePageLayout>
  );
};

 async function _getServerSideProps(context) {
  const slug = context.query.slug as string;
  const client = initializeClient({
    context,
  });

  const queries = await Promise.allSettled([
    client.query({
      query: GetStudioPageDocument,
      variables: { slug },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Main' },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Footer' },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Profile' },
    }),
  ]);

  const pageResult = queries[0];

  if (
    pageResult.status !== 'fulfilled' ||
    !pageResult?.value?.data?.studioBySlug
  ) {
    return {
      notFound: true,
    };
  }

  return addApolloState(client, {});
}

export default StudioDetail;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/studios/[slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  